import { render, staticRenderFns } from "./SiteArticlesConfig.vue?vue&type=template&id=0e3ac10e&"
import script from "./SiteArticlesConfig.vue?vue&type=script&lang=js&"
export * from "./SiteArticlesConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports